import { Dialog } from "@mui/material";

interface RejectConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const RejectConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
}: RejectConfirmationDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableScrollLock
      PaperProps={{
        sx: {
          borderRadius: "24px",
          margin: "16px",
        },
      }}
    >
      <div className="rounded-[24px] px-8 py-6">
        <div className="flex items-center justify-between  border-b border-[#E2E8F0] pb-4">
          <h2 className="text-xl font-medium text-[#1E293B]">
            Reject Refund Request
          </h2>
          <button onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#334155"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className="my-8">
          <p className="text-center text-base text-text">
            Are you sure you want to reject this request?
          </p>
        </div>
        <div className="flex items-center gap-4">
          <button
            onClick={onClose}
            className="h-10 flex-1 rounded-lg bg-button-background text-base font-medium text-text"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="h-10 flex-1 rounded-lg bg-[#F75C5C] text-base font-medium text-white"
          >
            Reject
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default RejectConfirmationDialog;
